<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaLocalidades"
    :search="search"
    :no-data-text="'Este projeto não possui localidades.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.opcoes="props">
        <v-btn color="primary" text icon @click="excluirLocalidade(props.item.id)" ><v-icon>delete</v-icon></v-btn>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaLocalidades.length }} localidades
      </template>
    </v-data-table>
    <br><br>
    <v-divider></v-divider>
    <v-card-actions v-if="projeto.funcao != null && projeto.funcao.item === 1">
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="toLimparLocalidades" >Limpar</v-btn>
      <v-btn color="primary" text @click="toNovaLocalidade" >Nova Localidade</v-btn>
      <v-btn color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    listaLocalidades: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Descrição', align: 'left', value: 'nome' },
      { text: 'Cidade', align: 'left', value: 'cidade.nomeCidade' },
      { text: 'Detalhes', align: 'left', value: 'detalhamento' },
      { text: 'CEP', align: 'left', value: 'cep' },
      { text: 'Excluir', align: 'left' }
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toNovaLocalidade: function () {
      this.$router.push({ name: 'NovaLocalidade', params: {idProjeto: this.idProjeto} })
    },
    toAvancar: function () {
      this.$router.push({ name: 'EditarArquivos', params: {idProjeto: this.idProjeto} })
    },
    toLimparLocalidades: function () {
      if (confirm('Deseja realmente exluir todas as localidades cadastradas?')) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' })
        this.listaLocalidades.forEach(item => {
          this.excluirLocalidade(item.id)
        })
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' })
      }
    },
    carregaLocalidades: function (idProjeto) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' })
      projetos.getListaLocalidade(this.idProjeto)
      .then(response => {
        this.listaLocalidades = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' })
      })
    },
    excluirLocalidade: function (idLocalidade) {
      projetos.deleteLocalidade(this.idProjeto, idLocalidade)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaLocalidades(this.idProjeto)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
      })
    }
  },
  mounted () {
    this.carregaLocalidades(this.idProjeto)
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-editar-abrangencia.vue?0eab311c